export async function parseApiResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  const rawText = await response.text();

  if (contentType.includes('application/json')) {
    return rawText ? JSON.parse(rawText) : {};
  }

  return {
    __nonJson: true,
    status: response.status,
    statusText: response.statusText,
    rawText,
  };
}
